// extracted by mini-css-extract-plugin
export default {"button":"secondary-button-v2_button__29BkN","buttonSecondary":"secondary-button-v2_buttonSecondary__iT9t8","buttonDefault":"secondary-button-v2_buttonDefault__MnJzq"};